import type { QueryClient } from '@tanstack/react-query';
import { invalidateTraining, queryKeys } from '../api/keys';
import { browserTimeZone } from '../lib/dates';
import { authClient } from './client';
import type { SessionUser } from './session';

export function timezoneToSync(user: SessionUser, browserZone: string): string | null {
  return user.timezone === 'UTC' && browserZone !== 'UTC' ? browserZone : null;
}

export async function syncTimezone(
  user: SessionUser,
  queryClient: QueryClient,
  browserZone: string = browserTimeZone(),
): Promise<SessionUser> {
  const zone = timezoneToSync(user, browserZone);
  if (zone === null) return user;
  const { error } = await authClient.updateUser({ timezone: zone });
  if (error !== null) return user;
  const updated = { ...user, timezone: zone };
  queryClient.setQueryData(queryKeys.session, updated);
  await invalidateTraining(queryClient);
  return updated;
}
